<div class="Welcome">
        <div class="row">
                <div class="col-md-12 col-lg-12 col-xs-12 col-sm-12">
                        <div class="container">
                                <h3 class="titleword">{{'Policy Wordings' | translate}}</h3>
                        </div>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-4 col-xs-12">
                        <div class="[ info-card ]">
                                <div class="ProductName Motor">
                                        <img src="assets/theme/en/images/4.png">
                                        <p style="text-align: center" class="CardTitle">{{'Motor Insurance' | translate }}</p>
                                        <div class="section">
                                                <button (click)="SelectDocument('Word')" class="btn btn-primary">{{'Policy Wording'|translate}}</button>
                                                <button (click)="SelectDocument('MID')" class="btn btn-primary">{{'MID'|translate}}</button>
                                        </div>

                                        <div class="section1 downloadTPLbtn" *ngIf="Select">
                                                <a style="font-weight: bold; color:maroon ;" href="{{url.DocumentURL}}Downloads/PolicyWordingTPL.pdf" target="_blank" download>{{'Download Third Party'|translate}}</a>
                                                <a style="color: #20559e;font-weight: bold;" href="{{url.DocumentURL}}Downloads/PolicyWordingCOMP.pdf" target="_blank" download>{{'Download Comprehensive'|translate}}</a>
                                        </div>
                                        <div class="section1 downloadMIDbtn" *ngIf="SelectMid">
                                                <a style="font-weight: bold; color:maroon ;" href="{{url.DocumentURL}}Downloads/MID.pdf" target="_blank" download>{{'Download MID'|translate}}</a>
                                                <a style="color: #20559e;font-weight: bold;" href="{{url.DocumentURL}}Downloads/MIDPlus.pdf" target="_blank" download>{{'Download MIDPlus'|translate}}</a>
                                        </div>

                                </div>


                        </div>
                </div>
                <div class="col-sm-6 col-md-4 col-lg-4 col-xs-12">
                        <div class="[ info-card ]">
                                <div class="ProductName Med">
                                        <img src="assets/theme/en/images/3.png">
                                        <p style="text-align: center" class="CardTitle">{{'Medical MalPractice Insurance' | translate }}</p>
                                        <div class="section">
                                                <!-- <a class="btn btn-primary"
                                                        href="{{url.DocumentURL}}Downloads/CommingSoon.jpg"
                                                        target="_blank" download>{{'Policy Wordings'|translate}}</a> -->
                                                <a class="btn btn-primary" href="{{url.DocumentURL}}Downloads/CommingSoon.jpg" target="_blank">{{'Policy Wordings'|translate}}</a>
                                        </div>


                                </div>
                        </div>
                </div>

                <div class="col-sm-6 col-md-4 col-lg-4 col-xs-12">
                        <div class="[ info-card ]">
                                <div class="ProductName Tra">
                                        <img src="assets/theme/en/images/1.jpg">
                                        <p style="text-align: center">{{'Travel Insurance' | translate }}</p>
                                        <div class="section">
                                                <a class="btn btn-primary" href="{{url.DocumentURL}}Downloads/PolicyWordingTravel.pdf" target="_blank">{{'Policy Wordings'|translate}}</a>
                                        </div>

                                </div>

                        </div>
                </div>



        </div>

        <div class="Clears">

        </div>


</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PolicyWordings/PolicyWordings.html